import { useEffect, useRef } from "react";
import { toast } from "sonner";

const MANIFEST_URL = `${process.env.PUBLIC_URL || ""}/asset-manifest.json`;
const POLL_MS = 60000;

async function fetchEntrypointHash() {
  try {
    const r = await fetch(`${MANIFEST_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!r.ok) return null;
    const data = await r.json();
    const entry = data.entrypoints || data.files;
    return JSON.stringify(entry);
  } catch {
    return null;
  }
}

export function useVersionCheck() {
  const baseline = useRef(null);
  const notified = useRef(false);

  useEffect(() => {
    let timer;

    async function check() {
      const current = await fetchEntrypointHash();
      if (!current) return;
      if (baseline.current === null) {
        baseline.current = current;
        return;
      }
      if (current !== baseline.current && !notified.current) {
        notified.current = true;
        toast("Nueva versión disponible", {
          description: "Actualiza para ver los últimos cambios.",
          duration: Infinity,
          action: {
            label: "Actualizar",
            onClick: () => window.location.reload(),
          },
        });
      }
    }

    check();
    timer = setInterval(check, POLL_MS);
    return () => clearInterval(timer);
  }, []);
}
